import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { getTenant } from '../services/global.service';
import { Store } from '@ngxs/store';
import { UserStateSelectors } from '../../store/users-store/user.selectors';
import { GetUser } from '../../store/users-store/user.actions';
import { firstValueFrom, filter, timeout } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OnboardingGuard implements CanActivate {
  private readonly router = inject(Router);
  private readonly store = inject(Store);

  async canActivate(): Promise<boolean> {
    const tenant = getTenant();
    const isDppTenant = tenant === 'dpp';

    if (!isDppTenant) {
      // Redirect non-DPP users to home page
      this.router.navigateByUrl('/home');
      return false;
    }

    // For DPP tenants, check if user is already onboarded
    let user = this.store.selectSnapshot(UserStateSelectors.getUser);

    // If user data is not loaded yet, try to fetch it
    if (!user) {
      this.store.dispatch(new GetUser());

      // Wait for user data to be loaded (with timeout)
      try {
        user = await firstValueFrom(
          this.store.select(UserStateSelectors.getUser).pipe(
            filter((u) => u !== null && u !== undefined),
            timeout(5000), // 5 second timeout
          ),
        );
      } catch {
        console.warn('Timeout waiting for user data, proceeding with onboarding');
        return true;
      }
    }

    if (user && user.isOnboarded) {
      // User is already onboarded, redirect to products page
      this.router.navigateByUrl('/products/list');
      return false;
    }

    return true;
  }
}
